import * as yup from 'yup';
import {
  emailRegex,
  namesRegex,
  msisdnRegex,
  isValidCheckSum,
  rsaIdRegex,
  nonRsaPassportRegex,
  rsaPassportRegex
} from '../../../constants';

export const validDirectorFields = [
  'firstName',
  'surName',
  'idType',
  'idNumber',
  'email',
  'msisdn',
  'title',
  'positionInCompany'
];

export const isPartialDirector = (director) => {
  return validDirectorFields.some(
    field =>
      director[field] === undefined ||
      director[field] === null ||
      director[field] === ''
  );
};

export const directorValidationSchema = yup.object().shape({
  directors: yup
    .array().of(
      yup.object().shape({
        positionInCompany: yup.string()
          .required('Position in the company is a required field'),
        title: yup.string()
          .required('Title is a required field'),
        idNumber: yup.string().when('idType', {
          is: 'id',
          then: () => yup.string().matches(rsaIdRegex, 'SA ID Number is not valid')
            .test('idNumber', 'SA ID Number is not valid', (item) => isValidCheckSum(item))
            .required('SA ID Number is a required field'),
          otherwise: () => yup.string().when('idType', {
            is: 'pp',
            then: () => yup.string().matches(nonRsaPassportRegex, 'Non RSA Passport Number is not valid')
              .required('Passport Number is a required field'),
            otherwise: () => yup.string().when('idType', {
              is: 'sapp',
              then: () => yup.string().matches(rsaPassportRegex, 'SA Passport Number is not valid')
                .required('Passport Number is a required field'),
              otherwise: () => yup.string().nullable().optional()
            })
          })
        }),
        firstName: yup
          .string()
          .trim()
          .required('Name is a required field')
          .matches(namesRegex, 'Name should contain letters only')
          .min(1, 'Name must be a valid Name consisting of at least 1 character')
          .max(40, 'Name must be a valid Name consisting of max 40 character'),
        surName: yup
          .string()
          .trim()
          .required('Surname is a required field')
          .matches(namesRegex, 'Surname should contain letters only')
          .min(1, 'Surname must be a valid Surname consisting of at least 1 character')
          .max(40, 'Surname must be a valid Name consisting of max 40 character'),
        msisdn: yup
          .string()
          .required('Mobile Number is a required field')
          .matches(msisdnRegex, 'Mobile Number must be a valid mobile number'),
        email: yup
          .string()
          .required('Email Address is a required field')
          .matches(emailRegex, 'Email Address must be a valid email address')
      })
    ).test('directors', 'atleast 1 director is required', (item) => Array.isArray(item) && item.length > 0)
});

export const validateDirectorEmails = (values) => {

  const errors = {};

  if (Array.isArray(values.directors) && values.directors.length > 0) {

    const emailCounts = values.directors.reduce((acc, dir, index) => {
      if (dir.email) {
        if (!acc[dir.email]) {
          acc[dir.email] = [];
        }
        acc[dir.email].push(index);
      }
      return acc;
    }, {});

    Object.values(emailCounts).forEach(indices => {
      if (indices.length > 1) {
        indices.forEach(index => {
          if (!errors.directors) {
            errors.directors = [];
          }
          if (!errors.directors[index]) {
            errors.directors[index] = {};
          }
          errors.directors[index].email = 'A company director already has this email address';
        });
      }
    });
  }

  return errors;
};

export const validateDirectorIdNumber = (values) => {

  const errors = {};

  if (Array.isArray(values.directors) && values.directors.length > 0) {

    const idNumberCounts = values.directors.reduce((acc, dir, index) => {
      if (dir.idNumber) {
        if (!acc[dir.idNumber]) {
          acc[dir.idNumber] = [];
        }
        acc[dir.idNumber].push(index);
      }
      return acc;
    }, {});

    Object.values(idNumberCounts).forEach(indices => {
      if (indices.length > 1) {
        indices.forEach(index => {
          if (!errors.directors) {
            errors.directors = [];
          }
          if (!errors.directors[index]) {
            errors.directors[index] = {};
          }
          errors.directors[index].idNumber = 'A company director already has this Id Number';
        });
      }
    });
  }

  return errors;
};